import styled from 'styled-components'

const BusinessIcon = styled.img`
  filter: grayscale(100%);
  padding: ${props => `0 ${props.theme.spacings.xs}`};
  display: inline-block;
`

export default BusinessIcon
